<template>
  <svg width="14" height="24" viewBox="0 0 14 14"  fill="#9FA1AA" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M13.8071 1.44412C13.8071 0.833008 13.3123 0.333008 12.7076 0.333008C12.1029 0.333008 11.6082 0.833008 11.6082 1.44412V12.5552C11.6082 13.1663 12.1029 13.6663 12.7076 13.6663C13.3123 13.6663 13.8071 13.1663 13.8071 12.5552V1.44412ZM5.20934 6.99967L0.932419 2.67745C0.514623 2.25523 0.514623 1.54412 0.932419 1.11079C1.13785 0.902754 1.41672 0.785848 1.70754 0.785848C1.99836 0.785848 2.27724 0.902754 2.48266 1.11079L7.52921 6.2219C7.73506 6.4295 7.85074 6.71133 7.85074 7.00523C7.85074 7.29913 7.73506 7.58096 7.52921 7.78856L2.48266 12.8886C2.20574 13.1684 1.80211 13.2777 1.42383 13.1753C1.04554 13.0728 0.750066 12.7742 0.648705 12.392C0.547343 12.0097 0.655495 11.6018 0.932419 11.3219L5.20934 6.99967Z"
      fill="#9FA1AA"></path>
   </svg>
</template>
<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>

<style></style>
